import React, { useState } from "react"
import { View } from "react-native"
import { TextInput } from "react-native-paper"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { TextInputMask } from "react-native-masked-text"
import { MaterialCommunityIcons } from "@expo/vector-icons"

export const InputGroup = (props) => {
    const [isFocused, setIsFocused] = useState(false)
    const [isPasswordShown, setIsPasswordShown] = useState(false)

    return (
        <View style={{ marginBottom: props?.marginBottom || 20 }}>
            <View style={{ flexDirection: "row", marginBottom: 7 }}>
                {props?.label?.length > 0 && (
                    <OpenSansText fontWeight={"bold"} fontSize={16}>{`${props?.label}`}</OpenSansText>
                )}
                <OpenSansText
                    color={
                        props?.valid == undefined
                            ? baseColors.black
                            : props?.valid && props?.valid == true
                            ? baseColors.black
                            : isFocused
                            ? baseColors.orange.dark
                            : baseColors.black
                    }
                    fontStyle="italic"
                    style={{ fontWeight: "normal", fontSize: 14 }}
                >
                    {!props?.valid && props?.validation_message?.length > 0 && ` (${props?.validation_message})`}
                </OpenSansText>
            </View>

            {props?.mask ? (
                <TextInputMask
                    maxLength={props?.maxLength}
                    placeholder={props?.placeholder}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        marginTop: 10,
                        padding: 15,
                        color: baseColors.green.primary,
                        fontSize: 16,
                        borderRadius: 10,
                        backgroundColor: isFocused ? baseColors.orange.light : baseColors.white,
                        borderWidth: isFocused ? 1.5 : 1,
                        borderColor: isFocused ? baseColors.orange.primary : "#444"
                    }}
                    type={props?.maskType ?? "custom"}
                    options={
                        {
                            // mask: "9999/9999"
                        }
                    }
                    value={props?.value}
                    onChangeText={(text) => {
                        props?.onChange(text)
                    }}
                />
            ) : (
                <TextInput
                    autoCapitalize="none"
                    editable={props?.editable ?? undefined}
                    multiline={props?.multiline}
                    onTouchStart={() => props?.onTouch?.()}
                    onSubmitEditing={() => props?.onSubmit?.()}
                    keyboardType={props?.code ? "decimal-pad" : "default"}
                    disabled={props?.disabled}
                    onChangeText={props?.onChange}
                    secureTextEntry={props?.type == "password" && !isPasswordShown}
                    style={{ height: props?.height ?? 0 }}
                    maxLength={props?.maxLength || 200}
                    placeholder={props?.placeholder}
                    onFocus={() => {
                        props?.onFocus && props?.onFocus()
                        setIsFocused(true)
                    }}
                    onBlur={() => setIsFocused(false)}
                    value={props?.value}
                    right={
                        props?.type == "password" && (
                            <TextInput.Icon
                                style={{ marginTop: "50%" }}
                                forceTextInputFocus={false}
                                onPress={() => setIsPasswordShown(!isPasswordShown)}
                                icon={() => (
                                    <MaterialCommunityIcons
                                        name={isPasswordShown ? "eye-off" : "eye"}
                                        size={24}
                                        color="gray"
                                    />
                                )}
                                color={isPasswordShown ? baseColors.green.primary : baseColors.grey}
                            />
                        )
                    }
                    theme={{
                        roundness: 10,
                        colors: {
                            text: baseColors.green.primary,
                            primary: baseColors.green.primary,
                            background: isFocused ? baseColors.green.light : "white"
                        }
                    }}
                    mode="outlined"
                />
            )}
        </View>
    )
}
